import { render, staticRenderFns } from "./WordReviewDialog.vue?vue&type=template&id=92383c94&scoped=true"
import script from "./WordReviewDialog.vue?vue&type=script&lang=js"
export * from "./WordReviewDialog.vue?vue&type=script&lang=js"
import style0 from "./WordReviewDialog.vue?vue&type=style&index=0&id=92383c94&prod&scoped=true&lang=css"
import style1 from "./WordReviewDialog.vue?vue&type=style&index=1&id=92383c94&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92383c94",
  null
  
)

export default component.exports